module.exports = __webpack_public_path__ + "static/media/img-sort-gray-active.dcf33453.svg";